import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import getImageUrl from '../utils/getImageUrl'
import getContentType from '../utils/getContentType'
import { color, mixin, bp, borderRadiusSmall } from '../globalStyles'
import BackgroundImage from './BackgroundImage'

const CardInner = styled.div`
  @media (${bp.desktop}) {
    margin: 1rem;
    width: 100%;
  }
`
const Title = styled.h4`
  margin-bottom: 0;
`
const SpeciesName = styled.div`
  margin-bottom: 0;
  font-size: 1.4rem;
  font-weight: 400;
  font-style: italic;
`
const Image = styled.div`
  min-height: 6.8rem;
  width: 10rem;
  margin-left: 1rem;
  flex-shrink: 0;
  position: relative;
  border-radius: ${borderRadiusSmall};
  overflow: hidden;
  background-color: ${color.lightGrey};

  .BackgroundImage {
    background-image: url(${props => props.imageSmall});
  }

  @media (${bp.desktop}) {
    .BackgroundImage {
      background-image: url(${props => props.imageLarge});
    }
  }
`
const Card = styled(Link)`
  ${mixin.card};
  ${mixin.cardHover};
  background: white;
  color: inherit;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (${bp.desktop}) {
    flex-direction: column;
    border: none;
    box-shadow: none;
    border-radius: ${borderRadiusSmall};
    padding: 0;
    width: 100%;

    &:hover,
    &:focus {
      box-shadow: none;
    }

    ${Image} {
      order: -1;
      height: 20rem;
      width: 100%;
      margin: 0;
    }
  }
`

const SpeciesCard = ({ item }) => {
  const { title, slug, mainImage, speciesName } = item.fields

  const contentType = getContentType(item)
  const imageSmall = getImageUrl(mainImage, 200)
  const imageLarge = getImageUrl(mainImage, 400)

  return (
    <Card to={`/${contentType}/${slug}`} className='Card'>
      <CardInner>
        {title && <Title>{title}</Title>}
        {speciesName && <SpeciesName>{speciesName}</SpeciesName>}
      </CardInner>
      <Image imageLarge={imageLarge} imageSmall={imageSmall}>
        <BackgroundImage />
      </Image>
    </Card>
  )
}

SpeciesCard.propTypes = {
  item: PropTypes.object.isRequired
}

export default SpeciesCard



// WEBPACK FOOTER //
// ./src/components/SpeciesCard.js